// extracted by mini-css-extract-plugin
var _1 = "DocFlowProfileHeaderConnectedRequests-modulelist__l2yTT RequestMultiValuedList-moduleRequestMultiValuedList__QDIf2 MultiValuedList-moduleMultiValuedList__ZJwbV";
export { _1 as "list" }
